import { UseFormReturn } from "react-hook-form";
import { useRouter } from "src/hooks/useRouter";
import { useModal } from "src/hooks/useModal";
import { Spinner } from "react-bootstrap";
import "./Join.style.scss";
import MsgModal from "components/Common/Modal/MsgModal";
import ProductCard from "components/Login/ProductCard";
import { JoinFormData } from "./Join.schema";
import FormInput from "components/Common/Form/Input/FormInput";
import { FormContainer } from "components/Common/Form/Input/FormContainer";
import Checkbox from "components/Common/Form/Checkbox";
import { SubmitBtn } from "components/Common/Form/SubmitBtn";
import { useTranslation } from "react-i18next";

interface IJoinUIProps {
  // 폼 관련
  joinForm: UseFormReturn<JoinFormData>;
  onJoinSubmit: (data: JoinFormData) => void;
  joinPossible: boolean;

  // 상태
  msgModalTitle: string;
  msgModalBody: string;
  showMsgModal: boolean;
  isSendTokenLoading: boolean;
  isSendTokenSuccess: boolean;
  isCheckTokenLoading: boolean;
  isCheckTokenSuccess: boolean;

  // 핸들러
  sendToken: () => void; // 이메일 인증 토큰 전송
  checkToken: () => void; // 인증 토큰 확인
  nextButton: () => void;
  // handleUserIdCheck: (userId: string) => void;
}

const JoinUI = (props: IJoinUIProps) => {
  const {
    // 폼 관련
    joinForm,
    onJoinSubmit,
    joinPossible,

    // 상태
    msgModalTitle,
    msgModalBody,
    showMsgModal,
    isSendTokenLoading,
    isSendTokenSuccess,
    isCheckTokenLoading,
    isCheckTokenSuccess,

    // 핸들러
    sendToken,
    checkToken,
    nextButton,
    // handleUserIdCheck,
  } = props;

  const { goLogin } = useRouter();
  const { openTermsService, openPrivatePolicy } = useModal();
  const { t } = useTranslation();
  return (
    <div className="joinBody">
      <div className="joinContainer">
        <ProductCard />
        <div className="joinCard">
          <div className="tabContainer">
            <div className="tab active">
              <span className="tabText">{t("logIn.signUp.title")}</span>
            </div>
            <div className="tab" onClick={goLogin}>
              <span className="tabText">{t("logIn.goToLoginBtn")}</span>
            </div>
          </div>

          <FormContainer onSubmit={joinForm.handleSubmit(onJoinSubmit)}>
            {/* 이메일 주소 */}
            <FormInput
              label={t("navBar.myAccount.email")}
              name="userId"
              register={joinForm.register}
              errors={joinForm.formState.errors}
              placeholder={t("logIn.enterUserEmail")}
              type="email"
              disabled={isSendTokenLoading || isSendTokenSuccess}
              isClearBtn={false}
            >
              <button
                type="button"
                onClick={sendToken}
                disabled={
                  isSendTokenLoading ||
                  isSendTokenSuccess ||
                  !!joinForm.formState.errors.userId
                }
                className="btn btn-gray width mg ml-10 sendBtn"
              >
                <span>
                  {isSendTokenLoading ? (
                    <>
                      <Spinner animation="border" role="status" size="sm" />
                      <span className="mg ml-6">Sending...</span>
                    </>
                  ) : (
                    t("logIn.signUp.otp.sendBtn")
                  )}
                </span>
              </button>
            </FormInput>

            {/* 인증 토큰 입력 */}
            <FormInput
              name="token"
              label={t("logIn.signUp.otp.title")}
              register={joinForm.register}
              errors={joinForm.formState.errors}
              placeholder={t("logIn.signUp.otp.enterMsg")}
              disabled={isCheckTokenLoading || isCheckTokenSuccess}
              success={{
                isSuccess: isCheckTokenSuccess,
                message: t("logIn.signUp.otp.successMsg"),
              }}
              isClearBtn={false}
            >
              <button
                type="button"
                onClick={checkToken}
                disabled={isCheckTokenLoading || isCheckTokenSuccess}
                className="btn btn-gray width mg ml-10 sendBtn"
              >
                <span>
                  {isCheckTokenLoading ? (
                    <>
                      <Spinner animation="border" role="status" size="sm" />
                      <span className="mg ml-6">Sending...</span>
                    </>
                  ) : (
                    t("logIn.signUp.otp.confirmBtn")
                  )}
                </span>
              </button>
            </FormInput>

            {/* 이름 입력 */}
            <FormInput
              label={t("logIn.signUp.name")}
              name="userName"
              register={joinForm.register}
              errors={joinForm.formState.errors}
              placeholder={t("logIn.signUp.name")}
            />

            {/* 회사명 입력 */}
            <FormInput
              label={t("logIn.signUp.companyName")}
              name="companyName"
              register={joinForm.register}
              errors={joinForm.formState.errors}
              placeholder={t("logIn.signUp.companyName")}
            />

            {/* 비밀번호 입력 */}
            <FormInput
              label={t("logIn.signUp.password")}
              name="password"
              type="password"
              register={joinForm.register}
              errors={joinForm.formState.errors}
              placeholder={t("logIn.signUp.password")}
              hint={t("logIn.signUp.passwordHint")}
            />

            {/* 비밀번호 확인 입력 */}
            <FormInput
              // label={t("logIn.signUp.confirmPassowrd")}
              label={t("logIn.signUp.confirmPassowrd")}
              name="passwordCheck"
              type="password"
              register={joinForm.register}
              errors={joinForm.formState.errors}
              placeholder={t("logIn.signUp.enterConfirmPassowrd")}
            />

            {/* 약관 동의 체크박스 */}

            <Checkbox
              name="isConfirmConditions"
              register={joinForm.register}
              errors={joinForm.formState.errors}
            >
              <label
                className="checkboxLabel"
                onClick={(e) => {
                  joinForm.setValue(
                    "isConfirmConditions",
                    !joinForm.getValues("isConfirmConditions")
                  );
                }}
              >
                {t("logIn.signUp.agreement1")}
                <a
                  onClick={(e) => {
                    // e.stopPropagation();
                    openTermsService();
                  }}
                >
                  <b className="text text--black">
                    {t("logIn.signUp.agreement2")}
                  </b>
                </a>
                {t("logIn.signUp.agreement3")}
                <a
                  onClick={(e) => {
                    // e.stopPropagation();
                    openPrivatePolicy();
                  }}
                >
                  <b className="text text--black">
                    {t("logIn.signUp.agreement4")}
                  </b>
                </a>
                {t("logIn.signUp.agreement5")}
              </label>
            </Checkbox>

            {/* 회원가입 버튼 */}
            <SubmitBtn
              text={t("logIn.signUp.goToSignUpBtn")}
              disabled={!joinPossible || !isCheckTokenSuccess}
            />
            {/* <div className="buttonContainer">
              <button
                type="submit"
                className="joinButton"
                disabled={!joinPossible}
              >
                <span>{t("logIn.signUp.goToSignUpBtn")}</span>
              </button>
            </div> */}

            {/* 로그인 링크 */}
            <div className="formDescription">
              <span className="formDescriptionText">
                {t("logIn.signUp.checkMember")}
              </span>
              <span className="formDescriptionLink">
                <a onClick={goLogin}>{t("logIn.signUp.goToLogin")}</a>
              </span>
            </div>
          </FormContainer>
        </div>
      </div>

      {/* 성공 모달 */}
      {showMsgModal && (
        <MsgModal
          msgModalTitle={msgModalTitle}
          msgModalBody={msgModalBody}
          showMsgModal={showMsgModal}
          nextButton={nextButton}
        />
      )}
    </div>
  );
};

export default JoinUI;
